import gql from "graphql-tag";
import {DOCUMENT_VIEWERFIELDS} from "./gqlDocumentViewerFields";

export const GET_DOCUMENT_BY_IDENTIFIER = gql`
	${DOCUMENT_VIEWERFIELDS}
	query GetDocumentByIdentifier($identifier: String!) {
		documentByIdentifier(identifier: $identifier ) {
			...DocumentViewerFields
		}
	}
`;
